import { UserDto } from 'src/dtos';
import { User } from 'src/models';

import { mapAccountDtoToModel } from './accounts.mappers';

export const mapUserDtoToModel = (userDto: UserDto): User => ({
  ...userDto,
  accounts: userDto.accounts.map(accountDto => mapAccountDtoToModel(accountDto)),
});
